import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  RequestProjectAccessDialogComponent,
  RequestProjectAccessDialogData,
} from './request-project-access-dialog.component';

@Component({
  selector: 'app-request-project-access',
  templateUrl: './request-project-access.component.html',
  styleUrls: ['./request-project-access.component.scss'],
})
export class RequestProjectAccessComponent {
  @Input() organization: string = '';
  @Input() userExistingProjects: string[] = [];

  constructor(private dialog: MatDialog) {}

  openDialog(): void {
    this.dialog.open(RequestProjectAccessDialogComponent, {
      width: '640px',
      maxWidth: '95vw',
      data: {
        organization: this.organization,
        userExistingProjects: this.userExistingProjects,
      } as RequestProjectAccessDialogData,
    });
  }
}
